const initGallery = () => {
    const config = new CarouselConfig();
    config.sliderSelector = "[data-gallery-widget] [data-slider]";
    config.cellAlign = CellAlign.center;
    config.contain = true;
    config.autoPlay = false;
    config.wrapAround = false;
    config.showArrows = false;
    config.activateCustomButtons = true;
    config.showDots = window.innerWidth <= 1024 ? true : false;
    config.groupCells = true;
    config.adaptiveHeight = true;
    config.imagesLoaded = true;
    const responsiveCarousel = new ResponsiveCarousel();
    responsiveCarousel.initCarousel(config);
};
